import CWBrowserLogo from "../../CWBrowserLogo";
import LockScreenImg from "../../../assets/images/lockScreen.svg";
import Online from "../../../assets/images/green.svg";
import Offline from "../../../assets/images/red.svg";
import useAuthStore from "../../../stores/useAuthStore";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";

const LockScreenView = ({ isOnline, handleLogin }) => {
  const userData = useAuthStore.getState().userData;
  if (!userData) return null;

  const username = getOAuthHeaders()?.username;

  const tillName = useAuthStore.getState().tillValue?.name;

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f0f4f8 0%, #e8edf5 50%, #f5f7fa 100%)",
        fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        position: "relative",
      }}
    >
      {/* Top-right status bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          padding: "16px 24px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        {tillName && (
          <span style={{ fontSize: "12px", color: "#888", fontWeight: 500 }}>
            Till: <strong style={{ color: "#1a1a2e" }}>{tillName}</strong>
          </span>
        )}
        <img src={isOnline ? Online : Offline} style={{ height: "16px" }} alt="" />
      </div>

      <div style={{ width: "100%", maxWidth: "400px" }}>
        {/* Logo */}
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "32px" }}>
          <CWBrowserLogo size={28} variant="light" />
        </div>

        {/* Card */}
        <div
          style={{
            background: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 16px rgba(0, 0, 0, 0.08), 0 0 1px rgba(0, 0, 0, 0.1)",
            padding: "36px 32px 28px",
            textAlign: "center",
          }}
        >
          {/* Lock icon */}
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #1a1a2e, #2d2d4e)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
            }}
          >
            <img src={LockScreenImg} style={{ width: "28px", filter: "brightness(0) invert(1)" }} alt="" />
          </div>

          <h2 style={{ margin: "0 0 4px", fontSize: "20px", fontWeight: 600, color: "#1a1a2e" }}>
            Screen Locked
          </h2>
          <p style={{ margin: "0 0 24px", fontSize: "13px", color: "#888" }}>
            Sign in to unlock your session
          </p>

          {/* Username field */}
          <div style={{ marginBottom: "20px", textAlign: "left" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: 500, color: "#444", marginBottom: "6px" }}>
              Username
            </label>
            <input
              readOnly
              type="text"
              value={username}
              style={{
                width: "100%",
                height: "42px",
                borderRadius: "8px",
                padding: "0 12px",
                color: "#1a1a2e",
                border: "1px solid #dde1e6",
                fontSize: "13px",
                fontWeight: 500,
                outline: "none",
                boxSizing: "border-box",
                background: "#f8f9fc",
              }}
            />
          </div>

          {/* Login button */}
          <button
            onClick={handleLogin}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "44px",
              backgroundColor: "#8DC63F",
              color: "#fff",
              fontSize: "14px",
              fontWeight: 600,
              borderRadius: "8px",
              border: "none",
              outline: "none",
              cursor: "pointer",
              transition: "background-color 0.2s",
              letterSpacing: "0.3px",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#7DB535")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#8DC63F")}
          >
            Sign In
          </button>
        </div>

        {/* Footer */}
        <p style={{ textAlign: "center", fontSize: "11px", color: "#aaa", marginTop: "24px" }}>
          CW Browser — Secure Business Workspace
        </p>
      </div>
    </div>
  );
};

export default LockScreenView;
